import { render } from "./EventJO.vue?vue&type=template&id=71eb4e43&scoped=true"
import script from "./EventJO.vue?vue&type=script&lang=js"
export * from "./EventJO.vue?vue&type=script&lang=js"

import "./EventJO.vue?vue&type=style&index=0&id=71eb4e43&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71eb4e43"]])

export default __exports__